import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <div className="header section">
        <h1><a className="title is-1" href="#">Gucode - ReactJS Tutorial</a></h1>
        <h2 className="subtitle is-3">Playing with React</h2>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js